import { useCallback, useEffect, useRef } from 'react';

export const useViewModel = ({ errors, onContentChange }) => {
  const refErrorPanel = useRef();

  const briefError = errors && errors.brief;

  useEffect(() => {
    if (briefError && refErrorPanel.current) {
      refErrorPanel.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, [briefError]);

  const handleContentChange = useCallback(
    (...value) => {
      if (onContentChange) {
        onContentChange(...value);
      }
    },
    [onContentChange]
  );

  return {
    briefError,
    handleContentChange,
    refErrorPanel,
  };
};
